module.exports = __webpack_public_path__ + "img/pr-23.7e54a485.png";